import { render, staticRenderFns } from "./NavAffix.vue?vue&type=template&id=c7669a92&scoped=true&"
var script = {}
import style0 from "./NavAffix.vue?vue&type=style&index=0&id=c7669a92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7669a92",
  null
  
)

export default component.exports